module.exports = __webpack_public_path__ + "img/res9.66aaab86.jpg";